import React from "react";
import styled from "styled-components";
import indiecita from "../../src/img/indiecita.png";
import cornetas from "../../src/img/top_con_cornetas.png";
import cerrar from "../../src/img/cerrar.png";
import fondoTrivia from "../../src/img/fondo_trivia.png";
import premiosTrivia from "../../src/img/premios_trivia.png";

const Confirmacion = ({ viewConfirmacion, setviewConfirmacion, size }) => {
  const handleClickCerrar = () => {
    setviewConfirmacion(false);
  };

  return (
    <DivGralCard>
      <div className="container">
        <div className="row">
          <div className="col">
            <DivCard
              size={size}
              className="card text-center animate__animated animate__fadeInDownBig"
            >
              <div className="card-header" style={{ color: "#ffffff" }}>
                <DivCerrar className="btn" id="btnCerrar">
                  <img
                    src={cerrar}
                    alt="cerrar"
                    onClick={() => handleClickCerrar()}
                  />
                </DivCerrar>
                <img src={cornetas} alt="cornetas" style={{ width: "230px" }} />
              </div>
              <div className="card-body" style={{ color: "#ffffff", paddingTop: "0px" }}>
                <ImgIndiecita src={indiecita} alt="indiecita" />
                <DivTexto>
                  <div style={{ fontSize: "xxx-large", fontFamily: "Figtree-Bold" }}>¡LISTO!</div>
                  <div style={{ fontSize: "x-large", fontFamily: "Figtree-SemiBold" }}>RECORDÁ QUE</div>
                  <div style={{ fontSize: "x-large", fontFamily: "Figtree-SemiBold" }}>PARTICIPÁS POR</div>
                </DivTexto>
                <ImgPremios src={premiosTrivia} alt="premios" />
                <ButtonCerrar
                  onClick={() => handleClickCerrar()}
                  className="btn"
                  id="botonCerrar"
                >
                  CERRAR
                </ButtonCerrar>
              </div>
            </DivCard>
          </div>
        </div>
      </div>
    </DivGralCard>
  );
};

export default Confirmacion;

const DivCard = styled.div`
  top: 3vh;
  min-width: 40vh;
  min-height: ${(props) => (props.size > 600 ? "90vh" : "71vh")};
  max-width: 61vh;
  background-color: #217bbe;
  background-image: url(${fondoTrivia});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
`;
const ButtonCerrar = styled.button`
margin-top: 2vh;
  min-width: 7em;
  border-radius: 5px !important;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #ffffff;
  font-family: "Figtree-SemiBold";
  position: relative;
  top: 6vh;
  @media (min-width: 600px) {
    top: 3vh;
  }
`;
const DivGralCard = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #0000005e;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3 !important;
`;
const ImgIndiecita = styled.img`
  z-index: -2 !important;
  position: fixed;
  height: 68%;
  right: 0vh;
  padding-top: 20px;
`;
const DivCerrar = styled.div`
  position: fixed;
  right: 1vh;
`;
const DivTexto = styled.div`
  color: #ffffff;
  margin-bottom: 2vh;
  line-height: 1.2;
  text-align: left;
  padding-left: 5vh;
`;
const ImgPremios = styled.img`
  width: 250px;
  margin: 0;
  display: block;
  position: relative;
  top: 4vh;
  left: 1vh;
  margin-bottom: 2vh;
`;
